import {
	Box,
	Heading,
	Stack,
	Text,
	Flex,
	Card,
	Icon,
	Separator,
	Center,
	Button,
} from '@welbe/design-system'
import React, { lazy, Suspense } from 'react'
import { FiCheck } from 'react-icons/fi'

const PayButton = lazy(() =>
	import('./PaymentButton').then(module => ({ default: module.PaymentButton })),
)

const colors = {
	black: '#0A1415',
	green: '#36CD69',
	lightGreen: 'rgba(54, 205, 105, 0.10)',
}

const items = [
	'Consultas ilimitadas con médicos especialistas a $180',
	'Consultas ilimitadas con médicos generales a $130',
	'Consultas ilimitadas con odontólogos a $130',
	'Acceso a +3,000 estudios médicos con precios preferenciales',
	'Acceso a más de 10 beneficios para cuidar tu salud',
	'Extiende tu membresía a otros 5 familiares o amigos',
]

export const Shopify = () => {
	return (
		<Box
			backgroundColor="gray.50"
			minHeight="100vh"
			width="100%"
			paddingY="2rem"
			fontFamily="Inter"
		>
			<Stack
				width="100%"
				maxW="1020px"
				margin="0 auto"
				gap="2rem"
				paddingX="1rem"
			>
				<Stack alignItems="center" gap="1rem">
					<Flex gap="1rem">
						<Heading
							as="h1"
							fontSize={{ base: '1.5rem', md: '1.875rem' }}
							color="green.900"
							textAlign={{ base: 'center', md: 'left' }}
							display={{ base: 'grid', md: 'flex' }}
							gap="0.5rem"
						>
							Bienvenido a la membresía
							<Heading
								as="h1"
								fontSize={{ base: '1.5rem', md: '1.875rem' }}
								color={colors.green}
							>
								TodosMX
							</Heading>
						</Heading>
					</Flex>
					<Text
						color={colors.black}
						textAlign={{ base: 'center', md: 'left' }}
						fontSize={{ base: '1.25rem', md: '1.5rem' }}
						fontWeight="500"
					>
						Estás a un paso de cuidar tu salud y la de tu familia
					</Text>
					<Box
						borderLeftRadius={{ base: '0.875rem', md: '2rem' }}
						borderRightRadius={{ base: '0.875rem', md: '2rem' }}
						background="rgba(108, 108, 255, 0.10)"
						border="1px solid rgba(108, 108, 255, 0.20)"
						padding="0.80rem 1.30rem"
						letterSpacing="-0.15px"
					>
						<Text fontSize="0.875rem" color={colors.black} lineHeight="20px">
							Después de realizar el pago, recibirás un código de acceso para
							ingresar a la App de Welbe y el enlace para descargarla en la App
							Store
						</Text>
					</Box>
				</Stack>

				<Stack width="100%" maxW="560px" margin="0 auto">
					<Card.Root width="100%" padding="1.56rem">
						<Card.Header
							mb="1.875rem"
							color={colors.black}
							fontWeight="400"
							lineHeight="24px"
						>
							Resumen de la orden de compra
						</Card.Header>
						<Card.Body>
							<Card.Root
								backgroundColor="green.900"
								padding="1rem"
								borderRadius="0.625rem"
								bgGradient="to-br"
								gradientFrom="green.900"
								gradientTo="green.600"
							>
								<Stack gap="0.25rem">
									<Flex justifyContent="space-between">
										<Text
											fontSize="1rem"
											color="white"
											fontWeight="400"
											lineHeight="24px"
										>
											Membresía de Salud Anual
										</Text>
										<Box
											backgroundColor={colors.green}
											fontSize="0.75rem"
											color="white"
											borderRadius="0.5rem"
											height="22px"
											padding="2px 0.5rem"
										>
											12 MSI
										</Box>
									</Flex>
									<Text
										fontSize="0.875rem"
										color="white"
										fontWeight="400"
										lineHeight="20px"
									>
										Protección completa para ti y tu familia por 12 meses
									</Text>
								</Stack>
							</Card.Root>

							<Stack gap="0.75rem" padding="1rem 0 2.5rem 0">
								<Text>Incluye:</Text>
								<Stack gap="0.75rem">
									{items.map((item, index) => (
										<Flex key={index} alignItems="center" gap="0.5rem">
											<Icon color={colors.green}>
												<FiCheck />
											</Icon>
											<Text
												fontSize="0.875rem"
												fontWeight="400"
												lineHeight="20px"
												color={colors.black}
											>
												{item}
											</Text>
										</Flex>
									))}
								</Stack>
							</Stack>
							<Separator />

							<Stack paddingY="1.5rem">
								<Flex justifyContent="space-between">
									<Text
										fontSize="1rem"
										fontWeight="400"
										lineHeight="24px"
										color="gray.500"
										letterSpacing="-0.312px"
									>
										Pago único de inscripción
									</Text>
									<Text
										fontSize="1rem"
										fontWeight="400"
										lineHeight="24px"
										color={colors.black}
									>
										$150 MXN
									</Text>
								</Flex>
								<Flex justifyContent="space-between">
									<Text
										fontSize="1rem"
										fontWeight="400"
										lineHeight="24px"
										color="gray.500"
										letterSpacing="-0.312px"
									>
										Costo de la membresía
									</Text>
									<Text
										fontSize="1rem"
										fontWeight="400"
										lineHeight="24px"
										color={colors.black}
									>
										$1,800 MXN
									</Text>
								</Flex>
							</Stack>
							<Separator />
							<Flex paddingY="1.5rem" justifyContent="space-between">
								<Text
									fontSize="1rem"
									fontWeight="400"
									lineHeight="24px"
									color={colors.black}
								>
									Total a pagar
								</Text>
								<Text
									fontSize="1.5rem"
									fontWeight="500"
									lineHeight="24px"
									color="green.900"
								>
									$1,950 MXN
								</Text>
							</Flex>
						</Card.Body>
						<Card.Footer display="grid" width="100%" gap="1.5rem">
							<Flex
								flexDirection={{ base: 'column', md: 'row' }}
								justifyContent="space-between"
								width="100%"
								padding="0.875rem"
								borderRadius="0.75rem"
								backgroundColor={colors.lightGreen}
							>
								<Text
									fontSize="0.875rem"
									color={colors.black}
									fontWeight="400"
									lineHeight="24px"
								>
									Paga en <strong>12 meses sin intereses</strong>
								</Text>
								<Text color={colors.green} fontSize="1rem" fontWeight="600">
									$150 MXN/mes
								</Text>
							</Flex>
							<Center>
								<Suspense
									fallback={
										<Button disabled loading>
											Pagar ahora
										</Button>
									}
								>
									<PayButton />
								</Suspense>
							</Center>
						</Card.Footer>
					</Card.Root>
				</Stack>
			</Stack>
		</Box>
	)
}
